export const getStoredGraphQLToken = () => {
  const graphQLTokensString = localStorage.getItem('uta.graphQLTokens');

  if (!graphQLTokensString) {
    return null;
  }

  const graphQLTokens = JSON.parse(graphQLTokensString);

  return graphQLTokens?.jwtToken;
};
